import React from "react";

export const CentroObraCellRenderer = (params: any) => {
  if (params.node.rowPinned) {
    return null;
  }

  if(params.value === null) return null;
  
  const centro = params.value && params.value.substring(0,3);
  const obra = params.value && params.value.substring(3,8);

  return (
    <span><strong className="centroCell">{centro}</strong>{` / `}<strong className='obraCell'>{obra}</strong></span>
  );
};